<template>
  <div class="lbv-search animated fadeIn roundedCard">
    <b-card>
      <h1 class="lbv-page-title">
        Roles API
      </h1>
      <form
        class="lbv-search-filter"
        @submit.prevent=""
      >
        <div class="leaklistFilters container">
          <b-row class="divider">
            <b-col cols="6">
              <b-row>
                <b-col cols="2">
                  <label>Role:</label>
                </b-col>
                <b-col cols="8">
                  <b-form-select
                    id="statusFilter"
                    v-model="roleSelection"
                    class="full-width"
                    @change.native="onChange"
                  >
                    <option
                      v-for="role in userRoles"
                      v-bind="$attrs"
                      :key="role.id"
                      :value="role.id"
                    >
                      {{ role.name }}
                    </option>
                  </b-form-select>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col>
                  <button
                    id=""
                    class="btn btn-primary applyFilter"
                    @click="$router.push('addApi2Role')"
                  >
                    Manage Roles
                  </button>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col>
                  <button
                    id="applyBtn"
                    type="submit"
                    class="btn btn-primary applyFilter"
                    @click.prevent="showUsers()"
                  >
                    Show Users
                  </button>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col>
                  <button
                    v-b-modal.modalCreateRole
                    variant="primary"
                    type="submit"
                    class="btn btn-primary applyFilter"
                    @click="showModal = true"
                  >
                    Create Role
                  </button>
                  <!-- <b-btn v-model="createRole" class="btn btn-primary applyFilter"
                  v-b-modal.modalCreateRole variant="primary"
                  @click="showModal = true">Create Role</b-btn>-->
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-row>
                <b-col cols="2">
                  <label>API:</label>
                </b-col>
                <b-col cols="8">
                  <b-form-select
                    id="statusFilter2"
                    v-model="apiSelection"
                    class="full-width"
                    @change.native="onChange2"
                  >
                    <option
                      v-for="api in APIs"
                      v-bind="$attrs"
                      :key="api.apiID"
                      :value="api.apiID"
                    >
                      {{ api.apiName }}
                    </option>
                  </b-form-select>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="3">
              <b-row>
                <b-col>
                  <button
                    type="submit"
                    class="btn btn-primary applyFilter"
                    @click="$router.push('addRole2Api')"
                  >
                    Manage APIs
                  </button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </form>
      <b-modal
        id="modalCreateRole"
        ref="newCreateRole"
        title="Create New Role"
        ok-variant="primary"
        ok-title="Create"
        @ok="createRole"
        @show="clearInput"
      >
        <div class="col-md-12">
          <b-form-group
            horizontal
            label="New Role Name:"
            :label-cols="6"
          >
            <b-form-input
              v-model="newRoleName"
              class="col-md-10 full-width "
              type="text"
              required
            />
          </b-form-group>
          <b-form-group
            horizontal
            label="New Role Description:"
            :label-cols="6"
          >
            <b-form-input
              v-model="newRoleDescription"
              class="col-md-10 full-width "
              type="text"
              required
            />
          </b-form-group>
        </div>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import rolesMixin from '../mixins/rolesMixin'

export default {
  name: 'AccessControl',
  mixins: [rolesMixin]
}
</script>
  <style scoped media="screen">
  .lbv-search .full-width {
    width: 100% !important;
  }

  .divider{
    height: 100px;
  }

</style>
